import metadata from "./SubscribePage.metadata.json5";
import messages from "./SubscribePage.messages";
import styles from "./SubscribePage.module.scss";
import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { renderContentFromMetadata } from "@jutro/uiconfig";
import { withAuthenticationContext } from "gw-digital-auth-react";
import LoginPageHeaderComponent from "../../components/LoginPageHeaderComponent/LoginPageHeaderComponent";
import CustomStickyFlyouts from "../../components/CustomStickyFlyouts/CustomStickyFlyouts";
import CustomFooterComponent from "../../components/CustomFooterComponent/CustomFooterComponent";
import { CustomIconUtil } from "gw-portals-util-js";
import SubscribeFormComponent from "../../components/SubscribeFormComponent/SubscribeFormComponent";


function SubscribePage(props) {
    
    useEffect(() => {
        document.title = "Subscribe - American Modern Insurance Group";
    });

    const overrides = {
        mainContainer: {
            className: "subscribe-main-container"
        },
        subscribePageContainer: {
            className: "subscribe-page-container"
        },
        policyHolderMainImage: {
            className: "policy-holder-main-image",
            src: CustomIconUtil.getLogoSrc("account-main-image.png")
        },
        subscribeComponentFormContainer: {
            className: "subscribe-component-form-container"
        }     
    };

     const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            loginPageHeaderComponent: LoginPageHeaderComponent,
            subscribeFormComponent: SubscribeFormComponent,
            customStickyFlyouts: CustomStickyFlyouts,
            customFooterComponent: CustomFooterComponent  
        }
    };

     const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrides,
        resolvers
    );

    return renderedContentFromMetadata;
}

export default withAuthenticationContext(withRouter(SubscribePage));